export function getPhoneNumberHref(phoneNumber: string) {
  return 'tel:' + phoneNumber.replace(/\s/g, '');
}
